import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { LoaderOnInitialLoading } from "@design-system/LoaderOnInitialLoading/LoaderOnInitialLoading";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { TablePageHeader } from "@components/pageHeader/TablePageHeader";
import { useBankReconciliationReportQuery } from "@api/accountingReports.api";
import { useBankReconciliationReportDownload } from "../views/useBankReconciliationReportDownload";
import { BankReconciliationReportContent } from "./BankReconciliationReportContent";
import { BankReconciliationReportDownload } from "./BankReconciliationReportDownload";

export const BankReconciliationReportPreviewPage: React.FC = () => {
    const { bankReconciliationId } = useParams<{
        bankReconciliationId: string;
    }>();
    const [search, setSearch] = useState("");
    const { bankReconciliationReport, generationDate } =
        useBankReconciliationReportQuery({
            bankReconciliationId,
            enabled: !!bankReconciliationId,
        });
    const { download: downloadReport, isDownloading: isDownloadingReport } =
        useBankReconciliationReportDownload(bankReconciliationId);

    if (!bankReconciliationId) {
        return <EmptyState header="Report not available" />;
    }

    if (bankReconciliationReport.isError) {
        return (
            <EmptyState
                header="Couldn't load report"
                body="Something went wrong loading this reconciliation report. Please try again."
            />
        );
    }

    return (
        <>
            <TablePageHeader
                search={search}
                onSearchChange={setSearch}
                isFullPage
            >
                <BankReconciliationReportDownload
                    onDownload={downloadReport}
                    disabled={
                        isDownloadingReport ||
                        bankReconciliationReport.isLoading ||
                        !bankReconciliationReport.isSuccess
                    }
                    loading={isDownloadingReport}
                />
            </TablePageHeader>
            <LoaderOnInitialLoading queryResult={bankReconciliationReport}>
                {bankReconciliationReport.data && (
                    <BankReconciliationReportContent
                        report={bankReconciliationReport.data}
                        search={search}
                        generationDate={generationDate}
                    />
                )}
            </LoaderOnInitialLoading>
        </>
    );
};
